/**
 * Establecer los datos de los consejos de prudencia Generales (P101 / P102 / P103) detalles del producto. 
 * 
 * @param Object state 
 * @param Array nextState 
 */
export function setGeneralsPrudenceTips(state, nextState) {
    state.generalsPrudenceTips = nextState;
}

/**
 * Establecer los datos de los consejos de prudencia asociados al producto. 
 * 
 * Categorías de Frases P ( Prevención, Intervención, Almacenamiento, Eliminación ).
 * 
 * @param Object state 
 * @param Array nextState 
 */
export function setPrudenceTips(state, nextState) {
    state.prudenceTips = nextState;
}

/**
 * Establecer los datos de los consejos de prudencia asociados al producto en formato para las etiquetas.
 * 
 * @param Object state 
 * @param Array nextState 
 */
export function setPrudenceTipsHtml(state, nextState) {
    state.prudenceTipsHtml = nextState;
}